import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ModalConcluirServicio.css';

const ModalConcluirServicio = ({ servicio, onClose, onUpdate }) => {
  const token = useSelector((state) => state.auth.token);
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const [formData, setFormData] = useState({
    qr: '',
    nombrePax: servicio.nombrePax || '',
    aerolinea: servicio.aerolinea || '',
    noVuelo: servicio.noVuelo || '',
    noAsiento: servicio.noAsiento || '',
    origenVuelo: servicio.origenVuelo || '',
    destinoVuelo: servicio.destinoVuelo || '',
    observaciones: '',
    eta: servicio.eta || '',
    tipoSilla: 'WCHR',
    servicioSolicitado: 'P. ATENCION',
    tipoVuelo: 'CONTACTO',
    origen: 'RESERVACION',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Función para procesar el QR y extraer datos
  const processQRCode = (qrText) => {
    // Lógica para extraer datos del QR, ajusta los índices según tu formato
    const match = qrText.match(/M1(.{1,20})/);
    const nombrePax = match ? match[1] : '';
    const noVuelo = qrText.substring(39, 43) || '';
    const aerolinea = qrText.substring(36, 38) || '';
    const noAsiento = qrText.substring(49, 52) || '';
    const origenVuelo = qrText.substring(30, 33) || '';
    const destinoVuelo = qrText.substring(33, 36) || '';
    setFormData((prevData) => ({
      ...prevData,
      nombrePax,
      noVuelo,
      aerolinea,
      noAsiento,
      origenVuelo,
      destinoVuelo,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updates = {
      ...formData,
      statusServicio: 'CONCLUIDO',
      horaFin: moment().format('YYYY-MM-DD HH:mm:ss'),
      usuarioFin: user.noColaborador,
    };

    try {
      await axios.put(
        `https://orionadministracion.com/api/servicios/${servicio.noServicio}`,
        updates,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success('Servicio concluido exitosamente', {
        position: 'top-right',
        autoClose: 3000,
      });
      setTimeout(() => {
        onUpdate();
        onClose();
      }, 3000);
    } catch (error) {
      console.error('Error al concluir servicio:', error);
      toast.error(
        'Hubo un error al concluir el servicio. Por favor, intente nuevamente.',
        { position: 'top-right', autoClose: 3000 }
      );
    }
  };
  const isSalida = servicio.tipoService === 'SALIDAS'; // o 'SALIDA', depende de tu base


  return (
    <div className="modal-overlay" onClick={onClose}>
      <ToastContainer />
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Concluir Servicio</h2>
        </div>
        <div className="modal-body">
          <form className="service-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>QR Pase de Abordar</label>
              <input
                type="text"
                name="qr"
                value={formData.qr}
                onChange={handleInputChange}
                onBlur={(e) => processQRCode(e.target.value)}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Nombre Pax</label>
              <input
                type="text"
                name="nombrePax"
                value={formData.nombrePax}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Aerolínea</label>
              <input
                type="text"
                name="aerolinea"
                value={formData.aerolinea}
                readOnly
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Número de Vuelo</label>
              <input
                type="text"
                name="noVuelo"
                value={formData.noVuelo}
                readOnly
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Número de Asiento</label>
              <input
                type="text"
                name="noAsiento"
                value={formData.noAsiento}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Origen Vuelo</label>
              <input
                type="text"
                name="origenVuelo"
                value={formData.origenVuelo}
                readOnly
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Destino Vuelo</label>
              <input
                type="text"
                name="destinoVuelo"
                value={formData.destinoVuelo}
                readOnly
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Observaciones</label>
              <input
                type="text"
                name="observaciones"
                value={formData.observaciones}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>ETA</label>
              <input
                type="time"
                name="eta"
                value={formData.eta}
                onChange={handleInputChange}
                className="form-control"
              />
            </div>
            <div className="form-group">
              <label>Tipo de Silla</label>
              <select
                name="tipoSilla"
                value={formData.tipoSilla}
                onChange={handleInputChange}
                className="form-control"
              >
                <option>WCHR</option>
                <option>WCHC</option>
                <option>UH</option>
              </select>
            </div>
            <div className="form-group">
              <label>Servicio Solicitado</label>
              <select
                name="servicioSolicitado"
                value={formData.servicioSolicitado}
                onChange={handleInputChange}
                className="form-control"
              >
                <option>P. ATENCION</option>
                <option>MOSTRADOR</option>
                <option>SALA</option>
              </select>
            </div>
            <div className="form-group">
              <label>Tipo de Vuelo</label>
              <select
                name="tipoVuelo"
                value={formData.tipoVuelo}
                onChange={handleInputChange}
                className="form-control"
              >
                <option>CONTACTO</option>
                <option>REMOTA</option>
                <option>ABORDAJE</option>
                <option>RECIBO</option>
              </select>
            </div>
            <div className="form-group">
              <label>Origen</label>
              <select
                name="origen"
                value={formData.origen}
                onChange={handleInputChange}
                className="form-control"
              >
                <option>RESERVACION</option>
                <option>AEROPUERTO</option>
              </select>
            </div>
            <button type="submit" className="btn-submit">
              Concluir Servicio
            </button>
          </form>
        </div>
        <div className="modal-footer">
          <button className="btn-close" onClick={onClose}>
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalConcluirServicio;
